import { gql } from '@apollo/client';

const GET_COMPANY_SALESDOCUMENTS = gql`
  query getCompanySalesDocuments($companyId: Int!, $documentType:DocumentType!, $filter:DocumentFilter!, $offset:Int!, $pageSize:Int!) {
    companyAdminContext {
      salesDocuments {
        getCompanySalesDocuments(companyId: $companyId, documentType:$documentType, filter:$filter, offset:$offset, count:$pageSize){
					salesDocuments{
						salesDocumentId
						documentNumber
						documentType
						documentStatus
		        documentDate
						customerName
						customerNo,
						yourReference,
						amountDue,
						unpaidAmount,
						category
						dueDate					
						
					}
					totalCount
				}			
      }
    }
  }
`;

export default GET_COMPANY_SALESDOCUMENTS;
